import { createFileRoute } from '@tanstack/react-router';
import { basicHead } from '../../utility/head';
import { FeatureArticle, featureSeo } from '../../components/FeatureArticle';
import { shareWithEmployees } from '../../assets/data/features/share-with-employees';

export const Route = createFileRoute('/_marketing/share-with-employees')({
  component: () => <FeatureArticle data={shareWithEmployees} />,
  ssr: true,
  loader: ({ location }) => ({
    pathname: location.pathname,
    seo: featureSeo(shareWithEmployees),
  }),
  head: basicHead,
});
